import React from 'react';
import { Circle, CircleDashed, InfoIcon } from 'lucide-react';

// Each tooth has a number and can be selected or have additional information
interface ToothProps {
    number: number;
    selected: boolean;
    hasInfo?: boolean;
    onClick: (number: number) => void;
    disabled?: boolean;
}

export const Tooth: React.FC<ToothProps> = ({ number, selected, hasInfo = false, onClick, disabled = false }) => {
    return (
        <div
            className={`relative flex flex-col items-center cursor-pointer transition-colors ${selected ? 'text-primary' : 'text-gray-500'
                } ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:text-primary-600'}`}
            onClick={() => !disabled && onClick(number)}
        >
            {selected ? (
                <>
                    <Circle className="h-7 w-7 stroke-primary fill-primary/20" />
                    {hasInfo && (
                        <div className="absolute -top-1 -right-1">
                            <InfoIcon className="h-3 w-3 text-blue-500 fill-blue-500" />
                        </div>
                    )}
                </>
            ) : (
                <CircleDashed className="h-7 w-7" />
            )}
            <span className="text-xs font-medium mt-1">{number}</span>
        </div>
    );
};